import { Injectable } from '@angular/core';
import { ActionComponent } from '../components/action/action.component';

@Injectable()
export class ActionColumnService {

    public calculateWidth(components: Array<ActionComponent>): number {
        const unique = Array.from(new Set(
            components.map((item: any) => {
                return item.name
            })
        ));

        components = unique
            .map((name) => {
                return components.find((c) => {
                    return c.name === name;
                })
            });

        const padding = 13;
        const margin  = 8;

        let width = 0;

        width += padding * 2

        components.forEach((component: ActionComponent) => {
            const element  = component.element;
            const position = element.getBoundingClientRect();

            width += position.width
                + margin;
        });

        // Remove the margin of the last element.
        width -= margin;

        return width;
    }

}


// WEBPACK FOOTER //
// ./libs/chassis-datatable/src/services/action-column.service.ts